(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.ForceCRM",
                {
                    url: "/ForceCRM",
                    component: "forcecrm",
                    PageTitle: "Force CRM",
                    requiredPermissions: "ForceCRM:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }],
                        purchased: ["purchaseApi", "userApi", function (purchaseApi, userApi) {
                            var o = null;
                            return userApi.getLoggedInUser().then(function (user) {
                                return purchaseApi.getUserOrders(user.Id).then(function (orders) {
                                    ng.forEach(orders, function (order) {
                                        if (order.MarketingStrategy === "ForceCrm") {
                                            o = order;
                                            var d = new Date(o.CompletedDate);
                                            var n = d.toLocaleDateString();
                                            o.PurchaseDate = n;
                                        }
                                    });
                                    return o;
                                });
                            });
                        }]
                    }
                });
        }
    ]);

    app.component("forcecrm",
        {
            templateUrl: "App/Resources/ForceCRM/ForceCRM.html",
            controller: forcecrmCtrl,
            bindings: {
                states: "<"
            }
        });

    forcecrmCtrl.$inject = ["eligibilityFormDialog", "surveys", "eligibilityFormApi", "userApi", "purchaseApi", "$mdDialog", "$interval", "amplitudeService"];

    function forcecrmCtrl(eligibilityFormDialog, surveys, eligibilityFormApi, userApi, purchaseApi, $mdDialog, $interval, amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        $ctrl.intervals = [];
        surveys.then(function (s) {         
            eligibilityFormApi.isEnrolled(s.forceCRMId).then(function (submitted) {               
                $ctrl.submitted = submitted;
            });                        
        });

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {             
                eligibilityFormDialog.open(event, s.forceCRMId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }

        $ctrl.verifyPurchased = function () {
            $ctrl.purchased = null;
            var o = null;
            return userApi.getLoggedInUser().then(function (user) {
                return purchaseApi.getUserOrders(user.Id).then(function (orders) {
                    ng.forEach(orders, function (order) {
                        if (order.MarketingStrategy === "ForceCrm") {
                            var d = new Date(order.CompletedDate);
                            var n = d.toLocaleDateString();
                            order.PurchaseDate = n;
                            o = order;
                            console.log(o);
                        }
                    });

                    if (o != null) {
                        ng.forEach($ctrl.intervals, function (interval) {
                            $interval.cancel(interval);
                        });
                        $ctrl.purchased = o;
                    }

                });
            });
        };

        $ctrl.verifyPurchased(); 

        $ctrl.openPurchaseDialog = function (event) {

            $mdDialog.show({
                bindToController: true,
                controllerAs: "$ctrl",
                controller: dialogCtrl,
                templateUrl: "App/Resources/PurchasePage/template.html",
                parent: ng.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    purchased: false,
                    orders: purchaseApi.getAllOrders(),
                    title: "Force CRM",
                    //purchaseOptions: [{ Description: "Force CRM - Monthly Recurring Payments", Amount: 99, IsRecurringPayment: true }],
                    purchaseOptions: [{ Description: "Force CRM - One Time Payment  ($500 per seat)", Amount: 500, IsRecurringPayment: false, PurchaseSeats: true }],
                    termsLink: "https://www.figmarketing.com/Documents/Terms_of_Use.pdf",
                    marketingDollars: purchaseApi.getMarketingDollars().then(function (response) {
                        return response.MarketingDollarsTotal;
                    }).catch(ng.noop)
                }
            }).then(function (paymentAmount) {
                if (paymentAmount > 0) {
                    //TODO: AP - Lets come up with a better way to verify the purchase after paytrace executed

                    $ctrl.intervals.push(
                        $interval(function () {
                            $ctrl.verifyPurchased();
                        }, 3000)
                    );
                }
                else $ctrl.verifyPurchased();
            });
        };

        $ctrl.redirectToForceCRM = function () {   

            //var w = window.open();
            //w.document.write("Loading...");
            //ForceCRMApi.getToken().then(function (result) {
            //        var url = ForceCRMSettings.baseUrl +
            //            "/Sso?accesstoken=" +
            //            result.Token +
            //            "&expiration=" +
            //            result.Expiration;
            //        if ($ctrl.delegateId) {
            //            var delegate = _.find($ctrl.delegates, function (row) { return row.Id === $ctrl.delegateId; });
            //            if (delegate)
            //                url += "&onBehalfOfUserId=" + delegate.OnBehalfOfUserId;
            //        } else if ($ctrl.onBehalfOfUser)
            //            url += "&onBehalfOfUserId=" + $ctrl.onBehalfOfUser.Id;                   
            //        w.location.href = url;
            //    },
            //    function error(x) {
            //        $ctrl.ssoError = true;
            //    });
        }
    }

    dialogCtrl.$inject = ["$mdDialog", "purchaseApi", "$window", "$timeout"];
    function dialogCtrl($mdDialog, purchaseApi, $window, $timeout) {
        var $ctrl = this;
        window.d = this;
        ng.extend($ctrl,
            {
                close: close,
                cancel: cancel,
                purchase: purchase,
                getPaymentAmount: getPaymentAmount,
                setup: setup               
            });

        function setup() {
            $ctrl.marketingDollarsToUse = 0;
            $ctrl.numberOfSeats = 0;

            if ($ctrl.purchaseOptions) {            
                $ctrl.selectedPurchaseOption = 0;               
                $ctrl.paymentAmount = ($ctrl.purchaseOptions[0].Amount * $ctrl.numberOfSeats);
            }           
        }

        $ctrl.setup();

        function getPaymentAmount() {
          
            var preMarketingDollarPrice = ($ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount *
                $ctrl.numberOfSeats);

            if ($ctrl.marketingDollarsToUse > $ctrl.marketingDollars) {
                $ctrl.marketingDollarsToUse = $ctrl.marketingDollars;
            }
            if ($ctrl.marketingDollarsToUse > preMarketingDollarPrice) {
                $ctrl.marketingDollarsToUse = preMarketingDollarPrice;
            }

            if ($ctrl.marketingDollarsToUse == null || $ctrl.marketingDollarsToUse < 0) {
                $ctrl.marketingDollarsToUse = 0;
            }

            $ctrl.paymentAmount = preMarketingDollarPrice - $ctrl.marketingDollarsToUse;                               
        }  

        function purchase(model) {            
            $ctrl.submittingOrder = true;
            $ctrl.error = false;
            var order = { Description: model.Description };
            order.PaymentAmount = $ctrl.paymentAmount;
            order.MarketingDollarsUsed = $ctrl.marketingDollarsToUse;
            order.MarketingStrategy = "ForceCrm";
            order.Total = ($ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount * $ctrl.numberOfSeats);
            order.AdditionalInfo = {
                NumberOfSeats: $ctrl.numberOfSeats,               
            }
            if (!!$ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].IsRecurringPayment)
                order.Frequency = 3;
            else
                order.Frequency = 0;
           
            return purchaseApi.purchase(order)
                .then(function (response) {

                    $ctrl.submittingOrder = false;
                    close($ctrl.paymentAmount);

                    if ($ctrl.paymentAmount > 0) {
                        $window.open(response, "_blank");
                        //$window.location.href = "/";       
                    }
                }).catch(function (error) {       
                    console.log(error);
                    $ctrl.submittingOrder = false;
                    $ctrl.error = true;
                });
        }

        function close(paymentAmount) {
            $mdDialog.hide(paymentAmount);
        }

        function cancel() {
            $mdDialog.cancel();
        }
    };
})(window.app, window.angular); // jshint ignore:line